export const LEVEL_TYPE_CONST = Object.defineProperties({},{
  NORMAL_PERSONNEL:{
    value:0,
  },
  ADMIN:{
    value:10,
  },
});
const exportDefault = {
  authKey: '',/*auth key*/
  thisUserId:'',/*fid*/
  loginType: '',/* login type 用户类型 1平台管理用户 2配件销售商 3配件采购商*/
  userPhone:'',/*u phone*/
  userName:'', /*uname*/
  level: '',/* 10公司管理员 0普通员工  */
  companyId: '',
  ifLoad1: 0,/*加载个人信息完成*/
  ifLoad2: 0,/*获得聊天token完成*/
}
Object.defineProperties(exportDefault,{
  chatToken: {
    value:{},
    writable:true,
  },
  setChatToken:{
    value({chatToken}) {
      this.chatToken = chatToken
    }
  },
  setUserInfo:{
    value({authKey, thisUserId, loginType, userPhone, userName, level, companyId}){
      this.authKey = authKey;
      this.thisUserId = thisUserId;
      this.loginType = loginType;
      this.userPhone = userPhone;
      this.userName = userName;
      this.level = level;
      this.companyId = companyId;
    },
  },
  setIfLoad1:{
    value(load) {
      this.ifLoad1 = load
    },
  },
  setIfLoad2:{
    value(load) {
      this.ifLoad2 = load
    }
  },
  clearInfo:{
    value() {
      this.setUserInfo({
        authKey:'',
        thisUserId:'',
        loginType:'',
        userPhone:'',
        userName:'',
        level:'',
        companyId:'',
      })
    }
  },
  clearChatToken:{
    value() {
      this.setChatToken({chatToken: ''});
    }
  },
  LOGIN_TYPE_CONST:{
    value:{},
  },
  CHAT_MESSAGE_TYPE:{
    value:{},
  },
  LEVEL_TYPE_CONST:{
    value:LEVEL_TYPE_CONST
  },
});
Object.defineProperties(exportDefault.LOGIN_TYPE_CONST,{
  BUYER:{
    value: 3,
  },
  DEALER:{
    value: 2,
  },
  WEB_ADMIN:{
    value: 1,
  }
});
/**
 * 发送聊天消息的时候 msgType
 * 0  富文本
 * 1  图片
 * 2  音频
 * 3  视频
 * 4  其他文件类型
 * 5  开单
 */
Object.defineProperties(exportDefault.CHAT_MESSAGE_TYPE,{
  RICH_TEXT:{
    value:0,
  },
  IMAGE:{
    value:1,
  },
  AUDIO:{
    value:2,
  },
  VIDEO:{
    value:3,
  },
  OTHER_FILE_TYPE:{
    value:4,
  },
  OPEN_ORDER:{
    value:5,
  },
});
export default exportDefault;
export const CHAT_MESSAGE_TYPE = exportDefault.CHAT_MESSAGE_TYPE;
export const LOGIN_TYPE_CONST = exportDefault.LOGIN_TYPE_CONST;
